<template>
    <v-app>
        <Toolbar title="Kinetic Central (Classic)"/>
        <v-content>
            <v-flex xs12 md10 offset-md1 v-if="userCanShip">
                <v-toolbar color="blue darken-2" dark>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="blue" @click="$router.push('/tidlogon')" v-if="userCanLogon">TID Logon</v-btn> -->
                    <v-btn color="blue" @click="$router.push('/shipping')">List Orders for Shipping</v-btn>
                    <v-btn color="blue" @click="$router.push('/complete')">List Completed</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="blue" @click="logoutDialog = true">Logout</v-btn>
                </v-toolbar>
            </v-flex>
            <GroupsList/>

            <GroupNew/>

            <v-dialog v-model="logoutDialog" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Log Out?</v-card-title>
                    <v-card-text>Please confirm that you want to log out of the system.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" flat @click.native="logout">Yes, log out</v-btn>
                        <v-btn color="green darken-1" flat @click.native="logoutDialog = false">No, cancel
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'

    import Toolbar from '../components/Toolbar'
    import GroupsList from '../components/GroupsList'
    import GroupNew from '../components/GroupNew'

    const fb = require('../firebase')

    export default {
        name: "Groups",
        components: {Toolbar, GroupsList, GroupNew},
        data() {
          return {
              logoutDialog: false
          }
        },
        mounted() {
            if (fb.auth.currentUser === null || fb.auth.currentUser === undefined || !this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
                return
            }
            this.fetchAll()
        },
        methods: {
            ...mapActions(['fetchAll', 'isUserLoggedIn']),
            userCanShip: function () {
                return this.$store.state.users[fb.auth.currentUser.uid].shipping === true
            },
            userCanLogon: function () {
                return this.$store.state.users[fb.auth.currentUser.uid].logon === true
            },
            logout: function () {
                fb.auth.signOut()
                    .then(() => {
                        this.$router.push({path: '/signin'})
                    })
            }
        }
    }
</script>

<style scoped>

</style>
